import { useGetIsEffectivelyMuted } from 'src/store/sound'
import VolumeMuteIcon from 'src/app/assets/icons/ico-volume-mute.svg'
import VolumeIcon from 'src/app/assets/icons/ico-volume.svg'
import { useGetIsAudioSettingsOpen, useUIActions } from 'src/store/ui'
import { FullScreenButtonContainer } from '../FullScreenButton'
import { Button } from '../Button'
import { AudioControlsDialog } from './components/AudioControlsDialog'

export function BroadcastControls() {
  const uiActions = useUIActions()
  const isAudioSettingsOpen = useGetIsAudioSettingsOpen()
  const isEffectivelyMuted = useGetIsEffectivelyMuted()

  const handleAudioClick = () => {
    uiActions.audioSettingsToggled()
  }

  return (
    <>
      <div className="broadcast-controls">
        <FullScreenButtonContainer />
        <Button
          className={`game-toolbar-btn ${isAudioSettingsOpen ? 'active' : ''}`}
          onClick={handleAudioClick}
          useDefaultClasses={false}
        >
          {isEffectivelyMuted ? <VolumeMuteIcon className="text-red" /> : <VolumeIcon />}
        </Button>
      </div>
      <AudioControlsDialog
        isOpen={isAudioSettingsOpen}
        onClose={() => {
          uiActions.audioSettingsOpened(false)
        }}
      />
    </>
  )
}
